"use strict";
/**
 * Branded types for ID safety in the game engine
 *
 * These types help prevent accidental mixing of Player IDs and User IDs
 * by using TypeScript's type system to enforce correct usage.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdHelpers = void 0;
/**
 * Type guards and conversion helpers
 */
exports.IdHelpers = {
    /**
     * Convert a string to PlayerId
     * Use this when you know the string is a valid Player ID
     */
    toPlayerId(value) {
        return value;
    },
    /**
     * Convert a string to UserId
     * Use this when you know the string is a valid User ID
     */
    toUserId(value) {
        return value;
    },
    /**
     * Convert a string to SessionId
     * Use this when you know the string is a valid Session ID
     */
    toSessionId(value) {
        return value;
    },
    /**
     * Convert a string to AdventureId
     * Use this when you know the string is a valid Adventure ID
     */
    toAdventureId(value) {
        return value;
    }
};
//# sourceMappingURL=ids.js.map